module.exports = __webpack_public_path__ + "img/doron.bc3d012f.svg";